import { useTranslation } from "react-i18next";
import CONSTANTS from "core/constants";

import PatientCardListItem from "./patientCardListItem";
import QuestionnairesPatientCardItem from "./questionnairesPatientCardItem";
import { Icon, Spacing } from "@mindlercare/ui-web";

type PatientCardProps = {
  selectedPsychologistId: number | string | undefined | null;
  patientUserId: number;
  onClose: () => void;
};

export const PatientCard = ({
  selectedPsychologistId,
  patientUserId,
  onClose,
}: PatientCardProps) => {
  const { t } = useTranslation();

  const psychologistId = selectedPsychologistId ?? null;
  return (
    <div>
      <PatientCardListItem
        onClose={onClose}
        to={`/patients/psychologist/${psychologistId}/patient/${patientUserId}/${CONSTANTS.PATIENT_CARD_TABS.BOOKINGS.toLowerCase()}`}
        dataTestId={"cy-slot-bookings-link"}
        linkText={t("BOOKINGS")}
        icon={<Icon.Calendar width={20} />}
      />
      <>
        <Spacing t={8} />
        <PatientCardListItem
          onClose={onClose}
          to={`/patients/psychologist/${psychologistId}/patient/${patientUserId}/${CONSTANTS.PATIENT_CARD_TABS.ICBT.toLowerCase()}`}
          dataTestId={"cy-slot-icbt-activity-link"}
          linkText={t("ICBT_ACTIVITY")}
          icon={<Icon.Article width={20} />}
        />
      </>
      <QuestionnairesPatientCardItem
        onClose={onClose}
        patientUserId={patientUserId}
      />
    </div>
  );
};
